import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {FieldArray, formValueSelector, reduxForm} from 'redux-form';
import {ff, form, Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import PolozkaApi from "../api/gen/cgo/PolozkaApi";
import {Button, Col, Row} from "reactstrap";
import * as ReactDOM from "react-dom";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import {withTranslation, WithTranslation} from "react-i18next";

const FOCUS_TIMEOUT = 150;

/**
 * Formulář pro hromadné přidání fakturačních položek k objednávce.
 */
class ObjednavkaAddPolozkyForm extends Component<WithTranslation> {

    polozkaInputs = [];

    static formName = 'ObjednavkaAddPolozkyForm';

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
    };

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (values.polozky && values.polozky.length > 0) {
            errors.polozky = [];
            for (let i = 0; i < values.polozky.length; i++) {
                if (values.polozky[i].polozka) {
                    if (!values.polozky[i].mnozstvi) {
                        errors.polozky[i] = {mnozstvi: t('validation.amount_required')};
                    } else if (!Number.isInteger(parseInt(values.polozky[i].mnozstvi)) || values.polozky[i].mnozstvi < 1) {
                        errors.polozky[i] = {mnozstvi: t('validation.amount_positive_integer')};
                    }
                }
                if (!values.polozky[i].polozka && values.polozky[i].mnozstvi) {
                    errors.polozky[i] = {polozka: t('validation.item_required')};
                }
            }
        }
        return errors;
    };

    constructor(props) {
        super(props);
        this.state = {
            objednavkaPolozky: [],
        }
    }

    componentDidMount() {
        // focus na první field
        if (this.polozkaInputs.length > 0) {
            const parent = ReactDOM.findDOMNode(this.polozkaInputs[0]);
            const elements = parent.getElementsByTagName("input");
            if (elements && elements.length > 0) {
                // hack - timeout je zde potřeba, jinak se focus provede dřív než blur
                setTimeout(() => elements[0].focus(), FOCUS_TIMEOUT);
            }
        }
    };

    createObjednavkaPolozkaFromPolozka = (polozka) => {
        return {
            polozkaId: polozka.id,
            danId: polozka.danId,
            plu: polozka.plu,
        }
    };

    handleMnozstviKeyPress = (index, fields, event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            const cenaField = document.getElementsByName(`polozky[${index}].cena`);
            if (cenaField.length > 0) {
                cenaField[0].focus();
            }
        }
    };

    handleCenaKeyPress = (index, fields, event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            const slevaField = document.getElementsByName(`polozky[${index}].sleva`);
            if (slevaField.length > 0) {
                slevaField[0].focus();
            }
        }
    };

    handleSlevaKeyPress = (index, fields, event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            const data = {...fields.get(index)};
            // pokud jsou vyplněny alespoň první dva fieldy a jedná se o poslední řádek, přidáme nový
            if (data.polozka && data.mnozstvi && (index + 1 === fields.length)) {
                fields.push({});
            }
            // posuneme focus na další řádek
            const form = event.target.form;
            const elementIndex = Array.prototype.indexOf.call(form, event.target);
            // hack - timeout je zde potřeba, protože pokud byl právě přidán nový řádek tak se do DOMu dostane až se zpožděním - tj. nelze na něj provést focus ihned
            setTimeout(() => form.elements[elementIndex + 2].focus(), FOCUS_TIMEOUT);
        }
    };

    clearCenaSleva = (i) => {
        this.props.change(`polozky[${i}].cena`, null);
        this.props.change(`polozky[${i}].sleva`, null);
    };

    handlePolozkaChanged = (i) => {
        this.clearCenaSleva(i);
        this.props.change(`polozky[${i}].mnozstvi`, null);
        const mnozstviField = document.getElementsByName(`polozky[${i}].mnozstvi`);
        if (mnozstviField.length > 0) {
            mnozstviField[0].focus();
        }
    };

    handleMnozstviChanged = (i, _, mnozstvi) => {
        const {objednavka} = this.props;
        const {polozky} = this.props;
        const polozka = polozky[i].polozka;
        if (mnozstvi > 0 && polozka) {
            const objednavkaPolozka = this.createObjednavkaPolozkaFromPolozka(polozka);
            objednavkaPolozka.mnozstvi = mnozstvi;
            ObjednavkaApi.validateObjednavkaPolozka(objednavka.id, objednavkaPolozka).then((updatedPolozka) => {
                this.props.change(`polozky[${i}].cena`, updatedPolozka.cena);
                this.props.change(`polozky[${i}].sleva`, updatedPolozka.sleva)
                // if (updatedPolozka.cena) {
                //     this.props.change(`polozky[${i}].cena`, updatedPolozka.cena);
                // }
                // if (updatedPolozka.sleva) {
                //     this.props.change(`polozky[${i}].sleva`, updatedPolozka.sleva)
                // }
                const {objednavkaPolozky} = this.state;
                objednavkaPolozky[i] = updatedPolozka;
                this.setState({objednavkaPolozky});
            });
        } else {
            this.clearCenaSleva(i);
        }
    };

    handleCenaChanged = (i, _, cena) => {
        const {objednavkaPolozky} = this.state;
        if (cena) {
            if (objednavkaPolozky[i] && objednavkaPolozky[i].cena !== Number(cena)) {
                this.props.change(`polozky[${i}].specCena`, true);
            } else {
                this.props.change(`polozky[${i}].specCena`, false);
            }
        } else if (!cena && objednavkaPolozky[i] && !objednavkaPolozky[i].cena) {
            this.props.change(`polozky[${i}].specCena`, false);
        }
    };

    handleSlevaChanged = (i, _, sleva) => {
        const {objednavkaPolozky} = this.state;
        if (sleva) {
            if (objednavkaPolozky[i] && objednavkaPolozky[i].sleva !== Number(sleva)) {
                this.props.change(`polozky[${i}].specCena`, true);
            } else {
                this.props.change(`polozky[${i}].specCena`, false);
            }
        } else if (!sleva && objednavkaPolozky[i] && !objednavkaPolozky[i].sleva) {
            this.props.change(`polozky[${i}].specCena`, false);
        }
    };

    renderPolozky = ({fields}) => {
        const {t} = this.props;
        return fields.length > 0 ? <div>
            {fields.map((field, i) => {
                return <Row key={i}>
                    <Col xs={5}>
                        <ff.ApiObjectSuggest
                            name={`polozky[${i}].polozka`}
                            label={false}
                            placeholder={t('search_for_item')}
                            dropdown={false}
                            removable={false}
                            renderSuggestion={item => item ? item.nazev : ""}
                            getItemValue={item => item ? item.nazev : ""}
                            filterSuggestions={value => PolozkaApi.getPolozky(value, false)}
                            onChange={this.handlePolozkaChanged.bind(this, i)}
                            ref={(input) => this.polozkaInputs.push(input)}
                        />
                    </Col>
                    <Col xs={2}>
                        <ff.Number
                            autocomplete={'off'}
                            int
                            name={`polozky[${i}].mnozstvi`}
                            label={false}
                            placeholder={t('amount')}
                            onKeyPress={this.handleMnozstviKeyPress.bind(this, i, fields)}
                            onChange={this.handleMnozstviChanged.bind(this, i)}
                        />
                    </Col>
                    <Col xs={2}>
                        <ff.Number
                            autocomplete={'off'}
                            double
                            name={`polozky[${i}].cena`}
                            label={false}
                            placeholder={t('price_per_mj')}
                            onKeyPress={this.handleCenaKeyPress.bind(this, i, fields)}
                            onChange={this.handleCenaChanged.bind(this, i)}
                        />
                    </Col>
                    <Col xs={2}>
                        <ff.Number
                            autocomplete={'off'}
                            double
                            name={`polozky[${i}].sleva`}
                            label={false}
                            placeholder={t('discount')}
                            onKeyPress={this.handleSlevaKeyPress.bind(this, i, fields)}
                            onChange={this.handleSlevaChanged.bind(this, i)}
                        />
                    </Col>
                    <Col xs={1}>
                        {i !== fields.length - 1 && <Button onClick={fields.remove.bind(this, i)}>
                            <Icon icon="trash-o"/>
                        </Button>}
                    </Col>
                </Row>
            })} </div> : <i>Žádné hodnoty</i>
    };

    render() {
        const {onClose, submitting, handleSubmit, error, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <FieldArray name="polozky" component={this.renderPolozky} />
                {error && <p className="text-danger">{error}</p>}
            </FormBody>
            <FormActions onClose={onClose} cancelButton={t('buttons.cancel')} submitButton={t('buttons.insert')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(ObjednavkaAddPolozkyForm.formName);

const mapStateToProps = state => ({
    polozky: selector(state, 'polozky'),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: ObjednavkaAddPolozkyForm.formName,
    initialValues: {polozky: [{}]},
    validate: ObjednavkaAddPolozkyForm.validate,
})(ObjednavkaAddPolozkyForm)));
